import React from 'react';
import { Button } from 'components/ui/button';

interface IProps {
  onClick: () => void | Promise<void>;
  id?: string;
}

const ExportBtn = ({ id, onClick }: IProps) => {
  return (
    <Button
      id={id || 'export-btn'}
      variant="secondary"
      size="sm"
      iconStart="download"
      className="ml-2"
      onClick={onClick}
    >
      Export
    </Button>
  );
};

export default ExportBtn;
